import React from 'react';
import { Flame, Anchor, TrendingUp, MessageCircle, Smile } from 'lucide-react';
import ScoreGauge from './ScoreGauge';
import { useT } from '@/lib/i18n';

/**
 * "Viral Analysis Panel" — premium card with 5 animated score gauges.
 * Props: insights = { scores: {viral, hook, retention, engagement, emotion} }
 */
const AIAnalysisCard = ({ insights, loading }) => {
  const { lang } = useT();
  if (loading) {
    return (
      <div className="rounded-2xl border border-white/10 bg-[#0a0a0a] p-6">
        <div className="h-5 w-40 bg-white/5 rounded animate-pulse mb-6" />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <div className="w-24 h-24 rounded-full bg-white/5 animate-pulse" />
              <div className="w-16 h-3 bg-white/5 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    );
  }
  const s = insights?.scores || {};
  const gauges = [
    { key: 'viral', value: s.viral, label: lang === 'fr' ? 'Viral' : 'Viral', icon: Flame, accent: '#D4FF00', suffix: '/100' },
    { key: 'hook', value: s.hook, label: lang === 'fr' ? 'Hook' : 'Hook', icon: Anchor, accent: '#FF6B35' },
    { key: 'retention', value: s.retention, label: lang === 'fr' ? 'Rétention' : 'Retention', icon: TrendingUp, accent: '#4ADE80', suffix: '%' },
    { key: 'engagement', value: s.engagement, label: lang === 'fr' ? 'Engagement' : 'Engagement', icon: MessageCircle, accent: '#60A5FA' },
    { key: 'emotion', value: s.emotion, label: lang === 'fr' ? 'Émotion' : 'Emotion', icon: Smile, accent: '#F472B6' },
  ];
  return (
    <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-[#0a0a0a] to-[#070707] p-6" data-testid="ai-analysis-card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-heading font-bold text-base sm:text-lg flex items-center gap-2">
          <Flame className="w-4 h-4 text-[#D4FF00]" />
          {lang === 'fr' ? 'Analyse virale IA' : 'AI Viral Analysis'}
        </h3>
        <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-600 font-mono hidden sm:inline">
          {lang === 'fr' ? 'Scores prédits' : 'Predicted scores'}
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
        {gauges.map((g) => (
          <ScoreGauge key={g.key} value={g.value} label={g.label} suffix={g.suffix} icon={g.icon} accent={g.accent} testid={`gauge-${g.key}`} />
        ))}
      </div>
    </div>
  );
};

export default AIAnalysisCard;
